<section class="content">
    <div class="container-fluid">
        <div class="row mt-3 mb-3">
            <div class="col-lg-3 mt-3 mb-3">
                <div class="form-floating ">
                    <select class="form-select" id="selectShop" aria-label="Floating label select example"
                            (change)="selectTrader($event)"> <!--[(ngModel)]="selectedShop"-->
                        <option selected>Select Shop name</option>
                        <option *ngFor="let trader of traderDetails"
                                value="{{trader.traderId}}">{{trader.traderName}}</option>
                    </select>
                    <label for="selectShop">Shop Name</label>
                </div>
            </div>
        </div>

        <form (ngSubmit)="onSubmit()" [formGroup]="saveShopDetails" id="saveShopDetails">
            <!--<div class="col-12">
                <h5 class="text-bold">Shop details</h5>
            </div>-->
            <div class="row mt-3 mb-3">
                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="shopName" placeholder="Enter Your Shop Name"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('shopName')?.invalid && saveShopDetails.get('shopName')?.touched,
                               'is-valid': saveShopDetails.get('shopName')?.valid && saveShopDetails.get('shopName')?.touched}">
                        <label>Shop Name<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.shopName"
                              class="error-text">{{shopRegisterErrors.shopName}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <select class="form-select" id="category" formControlName="shopType"
                                [ngClass]="{
                               'is-invalid': saveShopDetails.get('shopType')?.invalid && saveShopDetails.get('shopType')?.touched,
                               'is-valid': saveShopDetails.get('shopType')?.valid && saveShopDetails.get('shopType')?.touched}">
                            <option value="" disabled selected>Select Shop Type</option>
                            <option *ngFor="let type of shopType"
                                    value="{{type.catName}}">{{type.catName}}</option>
                        </select>
                        <label>Shop Type<span style="color:red;">*</span></label>
                        <span *ngIf="shopRegisterErrors.shopType"
                              class="error-text">{{shopRegisterErrors.shopType}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="gstNo" placeholder="Enter Your GST No"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('gstNo')?.invalid && saveShopDetails.get('gstNo')?.touched,
                               'is-valid': saveShopDetails.get('gstNo')?.valid && saveShopDetails.get('gstNo')?.touched}">
                        <label>GST No<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.gstNo"
                              class="error-text">{{shopRegisterErrors.gstNo}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="contactNo" placeholder="Enter Your Phone Number"
                               maxlength="10"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('contactNo')?.invalid && saveShopDetails.get('contactNo')?.touched,
                               'is-valid': saveShopDetails.get('contactNo')?.valid && saveShopDetails.get('contactNo')?.touched}"
                               (keypress)="OnlyNumbers($event)">
                        <label>Phone Number<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.contactNo"
                              class="error-text">{{shopRegisterErrors.contactNo}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="streetAddress"
                               placeholder="Enter Door no and address"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('streetAddress')?.invalid && saveShopDetails.get('streetAddress')?.touched,
                               'is-valid': saveShopDetails.get('streetAddress')?.valid && saveShopDetails.get('streetAddress')?.touched}">
                        <label>Door No & Street Name<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.streetAddress"
                              class="error-text">{{shopRegisterErrors.streetAddress}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="area" placeholder="Enter Your Area"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('area')?.invalid && saveShopDetails.get('area')?.touched,
                               'is-valid': saveShopDetails.get('area')?.valid && saveShopDetails.get('area')?.touched}">
                        <label>Area<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.area"
                              class="error-text">{{shopRegisterErrors.area}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="city" placeholder="Enter Your City"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('city')?.invalid && saveShopDetails.get('city')?.touched,
                               'is-valid': saveShopDetails.get('city')?.valid && saveShopDetails.get('city')?.touched}">
                        <label>City<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.city"
                              class="error-text">{{shopRegisterErrors.city}}</span>
                    </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="state" placeholder="Enter Your State Name"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('state')?.invalid && saveShopDetails.get('state')?.touched,
                               'is-valid': saveShopDetails.get('state')?.valid && saveShopDetails.get('state')?.touched}">
                        <label>State<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.state"
                              class="error-text">{{shopRegisterErrors.state}}</span>
                    </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="postalCode"
                               placeholder="Enter Your Zip/Postal Code"
                               (keypress)="OnlyNumbers($event)" maxlength="6"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('postalCode')?.invalid && saveShopDetails.get('postalCode')?.touched,
                               'is-valid': saveShopDetails.get('postalCode')?.valid && saveShopDetails.get('postalCode')?.touched}">
                        <label>Zip/Postal Code<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.postalCode"
                              class="error-text">{{shopRegisterErrors.postalCode}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="latitude" placeholder="Enter Your Latitude Point"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('latitude')?.invalid && saveShopDetails.get('latitude')?.touched,
                               'is-valid': saveShopDetails.get('latitude')?.valid && saveShopDetails.get('latitude')?.touched}">
                        <label>Latitude Point<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.latitude"
                              class="error-text">{{shopRegisterErrors.latitude}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="longitude" placeholder="Enter Your Longitude Point"
                               [ngClass]="{
                               'is-invalid': saveShopDetails.get('longitude')?.invalid && saveShopDetails.get('longitude')?.touched,
                               'is-valid': saveShopDetails.get('longitude')?.valid && saveShopDetails.get('longitude')?.touched}">
                        <label>Longitude Point<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.longitude"
                              class="error-text">{{shopRegisterErrors.longitude}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="upiIdOne" placeholder="Enter Your Merchant UPI ID">
                        <label>Merchant UPI ID</label>
                        <!--<span *ngIf="shopRegisterErrors.upiIdOne"
                              class="error-text">{{shopRegisterErrors.upiIdOne}}</span>-->
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input type="time" (keypress)="OnlyNumbers($event)" class="form-control"
                               formControlName="workingHrsAm" placeholder="AM" [ngClass]="{
                        'is-invalid': saveShopDetails.get('workingHrsAm')?.invalid && saveShopDetails.get('workingHrsAm')?.touched,
                        'is-valid': saveShopDetails.get('workingHrsAm')?.valid && saveShopDetails.get('workingHrsAm')?.touched}">
                        <label>Shop Open at AM<span class="text-danger">*</span></label>
                        <span class="error-text"
                              *ngIf="shopRegisterErrors.workingHrsAm">{{shopRegisterErrors.workingHrsAm}}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input type="time" (keypress)="OnlyNumbers($event)" class="form-control"
                               formControlName="workingHrsPm" placeholder="PM"
                               [ngClass]="{
                        'is-invalid': saveShopDetails.get('workingHrsPm')?.invalid && saveShopDetails.get('workingHrsPm')?.touched,
                        'is-valid': saveShopDetails.get('workingHrsPm')?.valid && saveShopDetails.get('workingHrsPm')?.touched}">
                        <label>Shop Close at PM<span class="text-danger">*</span></label>
                        <span class="error-text"
                              *ngIf="shopRegisterErrors.workingHrsPm">{{shopRegisterErrors.workingHrsPm}}</span>
                    </div>
                </div>
                <div class="col-12">
                    <hr class="mb-3">
                </div>
            </div>


            <div class="row mt-3 mb-3">
                <div class="col-12 mb-3">
                    <h6>Customer Pickup Details</h6>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <label>Customer Pickup<span class="text-danger">*</span></label>
                    <div class="row ml-3">
                        <div class="col-md-6 col-6 form-check">
                            <input class="form-check-input" type="radio" formControlName="customerPickup"
                                   value="Yes" (change)="selectCustomerPickup($event)">
                            <label class="form-check-label">Yes</label>
                        </div>
                        <div class="col-md-6 col-6 form-check">
                            <input class="form-check-input" type="radio" formControlName="customerPickup"
                                   value="No" (change)="selectCustomerPickup($event)">
                            <label class="form-check-label">No
                            </label>
                        </div>
                    </div>
                    <span *ngIf="shopRegisterErrors.customerPickup"
                          class="error-text">{{shopRegisterErrors.customerPickup}}</span>
                </div>

                <div *ngIf="customerPickupShow"
                     class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input class="form-control" formControlName="packingLeadTime"
                               placeholder="Enter Pickup Lead Time in Hrs"
                               (keypress)="OnlyNumbers($event)" maxlength="2"
                               [ngClass]="{
                        'is-invalid': saveShopDetails.get('packingLeadTime')?.invalid && saveShopDetails.get('packingLeadTime')?.touched,
                        'is-valid': saveShopDetails.get('packingLeadTime')?.valid && saveShopDetails.get('packingLeadTime')?.touched}">
                        <label>Pickup Lead Time Hrs<span class="text-danger">*</span></label>
                        <span *ngIf="shopRegisterErrors.packingLeadTime"
                              class="error-text">{{shopRegisterErrors.packingLeadTime}}</span>
                    </div>
                </div>
                <div class="col-12">
                    <hr class="mb-3">
                </div>
            </div>

            <div class="row mt-3 mb-3">
                <div class="col-12 mb-3">
                    <h6>Delivery details</h6>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <label>Door Delivery<span class="text-danger">*</span></label>
                    <div class="row ml-3">
                        <div class="col-md-6 col-6 form-check">
                            <input class="form-check-input" type="radio" id="orderProcessing1"
                                   formControlName="orderProcessing" value="Yes">
                            <label class="form-check-label">Yes</label>
                        </div>
                        <div class="col-md-6 col-6 form-check">
                            <input class="form-check-input" type="radio" id="orderProcessing2"
                                   formControlName="orderProcessing" value="No">
                            <label class="form-check-label">No</label>
                        </div>
                    </div>
                    <span *ngIf="shopRegisterErrors.orderProcessing"
                          class="error-text">{{shopRegisterErrors.orderProcessing}}</span>
                </div>

                <div class="row">
                    <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3"
                         *ngIf="this.saveShopDetails.get('orderProcessing')?.value === 'Yes'">
                        <div class="form-floating">
                            <input class="form-control" formControlName="minimumOrderValue"
                                   [ngClass]="{
                        'is-invalid': saveShopDetails.get('deliveryLeadDate')?.invalid && saveShopDetails.get('deliveryLeadDate')?.touched,
                        'is-valid': saveShopDetails.get('deliveryLeadDate')?.valid && saveShopDetails.get('deliveryLeadDate')?.touched}"
                                   placeholder="Enter Your Min Order Value for Free Delivery">
                            <label>Enter Your Min Order Value for Free Delivery</label>
                        </div>
                    </div>

                    <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3"
                         *ngIf="this.saveShopDetails.get('orderProcessing')?.value === 'Yes'">
                        <div class="form-floating">
                            <select class="form-select" formControlName="deliveryLeadDate" [ngClass]="{
                        'is-invalid': saveShopDetails.get('deliveryLeadDate')?.invalid && saveShopDetails.get('deliveryLeadDate')?.touched,
                        'is-valid': saveShopDetails.get('deliveryLeadDate')?.valid && saveShopDetails.get('deliveryLeadDate')?.touched}">
                                <option value="" selected disabled>Select Lead Date</option>
                                <option value="0">Same Day</option>
                                <option value="1">1 Day</option>
                                <option value="2">2 Day</option>
                                <option value="3">3 Day</option>
                                <option value="4">4 Day</option>
                                <option value="5">5 Day</option>
                                <option value="6">6 Day</option>
                                <option value="7">7 Day</option>
                                <option value="8">8 Day</option>
                                <option value="9">9 Day</option>
                                <option value="10">10 Day</option>
                            </select>
                            <label>Delivery Lead Date<span class="text-danger">*</span></label>
                            <span *ngIf="shopRegisterErrors.deliveryLeadDate"
                                  class="error-text">{{shopRegisterErrors.deliveryLeadDate}}</span>
                        </div>
                    </div>

                    <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3"
                         *ngIf="this.saveShopDetails.get('orderProcessing')?.value === 'Yes'">
                        <div class="form-floating">
                            <input type="time" (keypress)="OnlyNumbers($event)" class="form-control"
                                   formControlName="deliveryLeadTimeFrom" placeholder="AM"
                                   [ngClass]="{
                        'is-invalid': saveShopDetails.get('deliveryLeadTimeFrom')?.invalid && saveShopDetails.get('deliveryLeadTimeFrom')?.touched,
                        'is-valid': saveShopDetails.get('deliveryLeadTimeFrom')?.valid && saveShopDetails.get('deliveryLeadTimeFrom')?.touched}">
                            <label>Delivery Timing From<span class="text-danger">*</span></label>
                            <span class="error-text"
                                  *ngIf="shopRegisterErrors.deliveryLeadTimeFrom">{{shopRegisterErrors.deliveryLeadTimeFrom}}</span>
                        </div>
                    </div>

                    <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3"
                         *ngIf="this.saveShopDetails.get('orderProcessing')?.value === 'Yes'">
                        <div class="form-floating">
                            <input type="time" (keypress)="OnlyNumbers($event)" class="form-control"
                                   formControlName="deliveryLeadTimeTo" placeholder="PM"
                                   [ngClass]="{
                        'is-invalid': saveShopDetails.get('deliveryLeadTimeTo')?.invalid && saveShopDetails.get('deliveryLeadTimeTo')?.touched,
                        'is-valid': saveShopDetails.get('deliveryLeadTimeTo')?.valid && saveShopDetails.get('deliveryLeadTimeTo')?.touched}">
                            <label>Delivery Timing To<span class="text-danger">*</span></label>
                            <span class="error-text"
                                  *ngIf="shopRegisterErrors.deliveryLeadTimeTo">{{shopRegisterErrors.deliveryLeadTimeTo}}</span>
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <hr class="mb-3">
                </div>
            </div>


            <div class="row mt-3 mb-3">
                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div class="form-floating">
                        <input
                                type="file"
                                class="form-control"
                                placeholder="Shop Logo"
                                (change)="onFileChange($event)">
                        <label>Shop Logo<span class="text-danger">*</span></label>
                        <span class="error-text"
                              *ngIf="shopRegisterErrors.shopLogo">{{ shopRegisterErrors.shopLogo }}</span>
                    </div>
                </div>

                <div class="col-lg-3 col-xl-3 col-md-6 col-12 mb-3">
                    <div *ngIf="images" style="width: 100px; height: 100px;">
                        <img class="image-preview" [src]="images" alt="image" width="100" height="100">
                    </div>
                </div>

                <div class="col-12 mb-3">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="Accepted" id="acknowledge"
                               formControlName="acknowledge">
                        <a [routerLink]="['/privacy-policy']">
                            Click here to Acknowledge the Terms & Conditions
                        </a>
                        <span *ngIf="shopRegisterErrors.acknowledge"
                              class="error-text">{{shopRegisterErrors.acknowledge}}</span>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center mb-5">
                <button
                        type="submit"
                        class="btn btn-primary">
                    {{isUpdate ? "Update" : "Register"}}
                </button>

                <!-- <button type="submit"
                         class="btn btn-primary">{{isUpdate ? "Update" : "Register"}}</button>-->
                <!--<button *ngIf="!isUpdate" type="button" style="margin-left:5px; width: 100px;"
                        class="btn btn-secondary"
                        (click)="reload();">Reset
                </button>-->
            </div>
        </form>
    </div>
</section>